import { TwoHeading } from "./TwoHeading";
import * as theme from "../theme";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  Typography,
  Box,
  makeStyles,
  TextField,
  Tooltip,
  Link,
  Switch,
  FormControlLabel,
  FormGroup,
  Button,
} from "@material-ui/core";
import { readyTheCards } from "../store/helperfuncs";
import {
  getCoverTable,
  getCoverTypes,
  getBinderDetail,
  getBinderViewRows,
  getCovers,
  getBrokerComment,
  updateBinderCovers,
  updateRows,
  updateBrokerCover,
} from "../store/mybinder";
import { useForm } from "react-hook-form";
import AddEditSummary from "../components/AddEdit/AddEditSummary";
import TabPanel from "../components/AddEdit/TabPanel";
import { Constents } from "../components/AddEdit/Constant";
import Tabs from "../components/AddEdit/Tabs";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import _ from "lodash";
import { getBrokerInformation } from "../store/broker";

const useStyles = makeStyles((theme) => ({
  maindiv: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "rgb(239, 243, 247)",
  },
  secondDiv: {
    paddingLeft: "3.5vw",
    paddingRight: "3.5vw",
    paddingTop: "1vw",
  },
  thriddDiv: {
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    height: "50% !important",
    paddingLeft: "1.5vw",
    height: "88vh",
  },
  commentDiv: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "1vh",
    paddingTop: "3vh",
  },
  toggleLable: {
    position: "absolute",
    marginLeft: "2rem",
    "& .MuiTypography-body1": {
      fontFamily: "GibsonSemiBd !important",
      marginLeft: "-7rem",
      fontSize: "2.2vmin",
    },
  },
}));
const AddEditBinder = () => {
  const policyId = window.location.href.split("=").slice(-1)[0];
  const dispatch = useDispatch();
  const covers = useSelector(getCovers);
  const covertable = useSelector(getCoverTable);
  const covertypes = useSelector(getCoverTypes);
  const BinderDetail = useSelector(getBinderDetail());
  const brokerComment = useSelector(getBrokerComment);
  const rows = useSelector(getBinderViewRows);
  const [updatedCovers, setUpdatedCoverTable] = useState(null);
  const [updatedLocCovers, setUpdatedLocCoverTable] = useState(null);
  const [buffer, setBuffer] = useState(1);
  const [hasBuilding, setHasBuilding] = useState(false);
  const [buildingCount, setBuildingCount] = useState(null);
  const [cardsObject, setCardsObject] = useState(
    readyTheCards(rows, hasBuilding, buildingCount)
  );
  const [isEditBinder, setIsEditBinder] = useState(true);
  const [policyEditData, setPolicyEditData] = useState({});

  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  const [title, setTitle] = useState(
    languagepreference === "en"
      ? "Policy Level Coverages"
      : "Couvertures d’assurance"
  );

  const classes = useStyles();
  const { handleSubmit } = useForm();
  const setValue = ({
    value,
    id,
    isLocCov,
    locNum,
    comment,
    effectivedate,
    expirydate,
  }) => {
    let locTable = null;
    let policyTable = null;
    let newRows = [...rows];
    let inputvalue = Number(value);
    const index = rows.findIndex((el) => {
      if (el.id === id) {
        if (el.locationid) {
          if (el.locationid === locNum) return true;
          else return false;
        }
        return true;
      }
    });
    newRows[index] = { ...newRows[index], covervalue: inputvalue };
    dispatch(
      updateBinderCovers({
        policyId: policyId,
        covers: { ...covers, [id]: inputvalue },
      })
    );
    dispatch(updateRows({ rows: newRows }));
    if (id) {
      if (isLocCov) {
        locTable = JSON.parse(JSON.stringify(updatedLocCovers));
        if (!locTable) locTable = {};
        if (!locTable[locNum]) locTable[locNum] = {};
        locTable[locNum][id] = inputvalue;
        setUpdatedLocCoverTable(locTable);
      } else {
        policyTable = JSON.parse(JSON.stringify(updatedCovers));
        if (!policyTable) policyTable = {};
        policyTable[id] = inputvalue;
        setUpdatedCoverTable(policyTable);
      }
    }
    setPolicyEditData({
      policyid: policyId,
      covers: { ...covers, [id]: inputvalue },
      locationdata: locTable ? locTable : null,
      comment: comment ? comment : null,
      effectivedate: effectivedate ? effectivedate : null,
      expirydate: expirydate ? expirydate : null,
    });
  };

  useEffect(() => {
    if (covers && !updatedCovers) {
      setUpdatedCoverTable(covers);
    } else if (covertable && !updatedCovers) {
      let templateCovers = {};
      for (let coverid in covertable) {
        templateCovers[coverid] = "";
      }
      setUpdatedCoverTable(templateCovers);
    }
  }, []);

  // useEffect(() => {
  //   // Check if any location has a 'buildings' property
  // const buildingCheck = _.some(BinderDetail.locations, (location) =>
  //   _.has(location, "buildings")
  // );

  //

  //   setHasBuilding(buildingCheck);

  //

  //   setCardsObject(readyTheCards(rows, buildingCheck));
  // }, [rows]);

  useEffect(() => {
    const tempBuildingCount = {};
    if (!BinderDetail?.locations) {
      return;
    }

    const buildingCheck = _.some(BinderDetail.locations, (location) =>
      _.has(location, "buildings")
    );

    _.forEach(BinderDetail.locations, (location, locationId) => {
      if (_.has(location, "buildings")) {
        tempBuildingCount[locationId] = {
          buildingsCount: Object.keys(location.buildings).length,
        };
      } else {
        tempBuildingCount[locationId] = { buildingsCount: 0 };
      }
    });

    setBuildingCount(tempBuildingCount);
    setCardsObject(readyTheCards(rows, buildingCheck, tempBuildingCount));
    setHasBuilding(buildingCheck);
  }, [rows, BinderDetail?.locations]);

  useEffect(() => {
    setCardsObject(readyTheCards(rows, hasBuilding, buildingCount));
  }, [hasBuilding]);

  const onSubmit = () => {
    if (policyEditData) {
      dispatch(updateBrokerCover(policyEditData));
    }
  };
  return (
    <div className={classes.maindiv}>
      <form id="form" onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.secondDiv}>
          <div className={classes.thriddDiv}>
            <div>
              <div>
                {Object.keys(cardsObject)?.map((key, index) => {
                  if (key == "RESPONSE")
                    return (
                      <AddEditSummary
                        key={index}
                        isEditBinder={isEditBinder}
                        setValue={setValue}
                        card={cardsObject[key]}
                        classes={classes}
                        onSubmit={onSubmit}
                        handleSubmit={handleSubmit}
                      ></AddEditSummary>
                    );
                })}
              </div>
              <div className={classes.commentDiv}>
                <div style={{ display: "flex" }}>
                  <Typography
                    variant="h5"
                    component="h5"
                    style={{
                      ...theme.labelStyles,
                    }}
                  >
                    {Constents?.COMMENTS[languagepreference]}
                  </Typography>
                </div>
                <TextField
                  id="outlined-multiline-static"
                  multiline
                  rows={2}
                  variant="outlined"
                  placeholder={
                    brokerComment
                      ? brokerComment
                      : Constents?.COMMENT_TEXT[languagepreference]
                  }
                  style={{ backgroundColor: "white" }}
                  onBlur={(event) => {
                    setTimeout(() => {
                      setValue({ comment: event.target.value });
                    }, 400);
                  }}
                  disabled={isEditBinder}
                />
              </div>
            </div>
            <div style={{ margin: "0 2.5rem" }}>
              <div>
                <div style={{ display: "flex" }} className="col-12">
                  <div style={{ display: "flex" }} className="col-9">
                    <Typography
                      variant="h5"
                      component="h5"
                      style={{
                        ...theme.labelStyles,
                      }}
                    >
                      {title}
                    </Typography>
                  </div>
                  <div style={{ display: "flex", marginLeft: "4rem" }}>
                    {/* <FormGroup>
                      <FormControlLabel
                        label={Constents.EDIT_LABLE}
                        className={classes.toggleLable}
                        style={{
                          ...theme.labelStyles,
                        }}
                        control={
                          <Switch
                            style={{
                              fontFamily: "GibsonSemiBd",
                              fontSize: "2.2vmin",
                              color: theme.COLORS.secondary_skyblue,
                            }}
                            onChange={() => setIsEditBinder(!isEditBinder)}
                          />
                        }
                      />
                    </FormGroup>
                    <Button
                      style={{
                        ...theme.labelStyles,
                      }}
                      style={{
                        ...theme.labelStyles,
                        marginTop: " -0.2rem",
                        textTransform: "none",
                        marginLeft: "6rem",
                      }}
                      onClick={onSubmit}
                    >
                      {Constents.SAVE_BTN}
                    </Button> */}
                  </div>
                </div>

                <Box
                  sx={{
                    display: "flex",
                    height: "100%",
                  }}
                >
                  <Tabs
                    buffer={buffer}
                    setBuffer={setBuffer}
                    cardsObject={cardsObject}
                    setTitle={setTitle}
                    covertypes={covertypes}
                  ></Tabs>
                  {Object.keys(cardsObject).map((key, index) => {
                    if (key == "RESPONSE") return <div key={index} />;
                    else {
                      const card = cardsObject[key];
                      if (Array.isArray(card) || !hasBuilding) {
                        return (
                          <TabPanel
                            card={card}
                            key={index}
                            value={buffer}
                            // responseid={props.responseid}
                            cardname={key}
                            index={index}
                            locNum={
                              card[0]?.locationid
                                ? card[0]?.locationid
                                : index + 1
                            }
                            // locationCovers={
                            //   responseDetail?.locations?.[
                            //     card[0].locationid
                            //       ? card[0].locationid
                            //       : index + 1
                            //   ]
                            // }
                            // setUpdating={setIsUpdatingCovs}
                            // getUpdating={isUpdatingCovs}
                            setValue={setValue}
                            covertable={covertable}
                            style={{ width: "80%", overflow: "hidden" }}
                            // responseid={responseid}
                          ></TabPanel>
                        );
                      } else {
                        return (
                          <div
                            style={{
                              padding: buffer === index ? "20px" : "0px",
                              width: buffer === index ? "100%" : "0px",
                            }}
                          >
                            <Accordion
                              hidden={buffer !== index}
                              defaultActiveKey="0"
                            >
                              {Object.keys(card).map(
                                (buildingKey, buildingIndex) => {
                                  return (
                                    <Card key={buildingKey}>
                                      <Accordion.Toggle
                                        as={Card.Header}
                                        eventKey={buildingIndex.toString()}
                                      >
                                        {buildingKey}
                                      </Accordion.Toggle>
                                      <Accordion.Collapse
                                        eventKey={buildingIndex.toString()}
                                      >
                                        <Card.Body>
                                          <TabPanel
                                            card={card[buildingKey]}
                                            key={buildingKey}
                                            value={buffer}
                                            buildingIndex={buildingIndex}
                                            // responseid={props.responseid}
                                            cardname={key + "-" + buildingKey}
                                            index={index}
                                            locNum={
                                              card[buildingKey][0].locationid
                                                ? card[buildingKey][0]
                                                    .locationid
                                                : index + 1
                                            }
                                            buildingData={
                                              BinderDetail?.locations[
                                                card[buildingKey][0]?.locationid
                                              ]?.buildings[buildingIndex]
                                            }
                                            // locationCovers={
                                            //   responseDetail?.locations?.[
                                            //     card[buildingKey][0].locationid
                                            //       ? card[buildingKey][0]
                                            //           .locationid
                                            //       : index + 1
                                            //   ][buildingKey]
                                            // }
                                            // setUpdating={setIsUpdatingCovs}
                                            // getUpdating={isUpdatingCovs}
                                            setValue={setValue}
                                            covertable={covertable}
                                            style={{
                                              width: "80%",
                                              overflow: "hidden",
                                            }}
                                            // responseid={responseid}
                                          ></TabPanel>
                                        </Card.Body>
                                      </Accordion.Collapse>
                                    </Card>
                                  );
                                }
                              )}
                            </Accordion>
                          </div>
                        );
                      }
                    }
                  })}
                </Box>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
export default AddEditBinder;
